import React from 'react';
import PropTypes from 'prop-types';
import linkUtils from 'src/utils/linkUtils';
import UserLink from 'src/modules/shared/links/userLink';
import signupContext from 'src/constants/signupContext';
import { trackFootfallEvent } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import classNames from 'classnames';

const CommunityHeaderNewbies = ({ newbies, currentUser, community, className }) => {
  const newbiesClassName = classNames({
    'community-header__newbies': true,
    [className]: !!className,
  });
  return (
    <div className={newbiesClassName}>
      {newbies.map(newbie => (
        <UserLink
          avatar={true}
          avatarSize="xsmall"
          className="community-header__newbie"
          isLoggedIn={!!currentUser}
          key={`newbie-${newbie.userId}`}
          signupContext={{
            element: signupContext.element.AVATAR,
            section: signupContext.section.COMMUNITY,
          }}
          user={{
            ...newbie,
            avatar: linkUtils.generateAvatarLinkFromHash(newbie.profileImageHash),
          }}
          onClick={() => {
            if (!currentUser) {
              trackFootfallEvent(footfallEventTypes.CLICKED, {
                clickType: 'sign-up',
                clickMetadata: { section: 'community-home', element: 'newbies' },
              });
            }
          }}
        />
      ))}
      <a href={`${community.slug}/members`}>
        <span className="icon icon-forwards-arrow" />
      </a>
    </div>
  );
};

export default CommunityHeaderNewbies;



// WEBPACK FOOTER //
// ./src/modules/community/shared/components/header/communityHeaderNewbies.js